import { Flex, FormLabel, Text } from "@chakra-ui/react";
import * as Question from "src/services/formTemplate/question";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { ArchivedTag } from "../QuestionExtraInfo/ArchivedTag";
import { SchoolItem } from "../types";
import { Eligibility } from "./Eligibility";

type AvailableAnswersProps = {
  question: AF.V2.Question;
  schools: RD.RemoteData<unknown, SchoolItem[]>;
};
export const AvailableAnswers: React.FC<AvailableAnswersProps> = ({
  question,
  schools,
}) => {
  if (!Question.hasOptions(question)) {
    return null;
  }

  const options = question.options;
  if (options.length === 0) return null;
  return (
    <Flex direction="column" gap="2">
      <FormLabel as={Text} margin="0">
        Available answers
      </FormLabel>
      <Flex direction="column" gap="2" as="dl">
        {options.map((option) => (
          <Flex key={option.id} gap="2" flexDirection="column">
            <Flex direction="row" gap="2">
              {option.isArchived && <ArchivedTag />}
              <Text as="dt" color="blackAlpha.700">
                {option.label}
                {!!option.value && ` | Answer value: ${option.value}`}
              </Text>
            </Flex>

            {!option.isArchived && (
              <Eligibility option={option} schools={schools} />
            )}
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
